/**
 * Toggles the 'no-scroll' class on the document element (<html>)
 *
 * @param {boolean|null} shouldScroll Whether to scroll or not, no param will toggle
 *
 * @return void
 */
export function toggleScroll( shouldScroll = null ) {
    document.documentElement.classList.toggle( 'no-scroll', !shouldScroll );
}
